<template>
    <div class="bo-coupon-list">
        <div
            class="coupons"
            v-for="coupon in formattedCoupons"
            :key="coupon.index"
        >
            <div class="coupon-action">
                <!-- <div
                    v-if="coupon.discount_type == 'percentage'"
                    class="title"
                >
                    {{
                        cartTranslations.percentage_off.replace(":discount", coupon.discount) ??
                        coupon.discount.concat("% Off")
                    }}
                </div>
                <div
                    v-else
                    class="title"
                >
                    {{ currencySymbol }} {{ coupon.discount }}
                </div>
                <button
                    v-if="button"
                    @click="onClick(coupon)"
                    class="btn-rounded btn-primary"
                    :disabled="!coupon.active"
                >
                    {{ coupon.action.toUpperCase() }}
                </button> -->
                <button
                    v-if="button"
                    @click="onClick(coupon)"
                    class="radio-button"
                    :disabled="!coupon.active"
                ></button>
            </div>

            <div class="coupon-info">
                <div class="d-flex">
                    <div class="coupon-details">
                        <div class="coupon-period theme-secondary-bg-color">
                            {{ convertDate(coupon.start_at) }} - {{ convertDate(coupon.end_at) }}
                        </div>
                        <!-- <div class="coupon-period theme-secondary-bg-color">
                            Used on {{ convertDate(coupon.used_at) }}
                        </div> -->
                        <div class="coupon-code">{{ coupon.code }}</div>
                        <div
                            v-if="coupon.discount_type == 'percentage'"
                            class="coupon-title theme-primary-color"
                        >
                            {{
                                cartTranslations.percentage_off_type
                                    ?.replace(":coupon_name", coupon.name)
                                    .replace(":discount", coupon.discount)
                                    .replace(":coupon_type", convertType(coupon.type)) ??
                                coupon.name.concat(" ", coupon.discount, "% off on ", convertType(coupon.type))
                            }}
                        </div>
                        <div
                            v-else
                            class="coupon-title theme-primary-color"
                        >
                            {{
                                cartTranslations.absolute_off_type
                                    ?.replace(":coupon_name", coupon.name)
                                    .replace(":discount", coupon.discount)
                                    .replace(":coupon_type", convertType(coupon.type)) ??
                                coupon.name.concat(
                                    " ",
                                    currencySymbol,
                                    coupon.discount,
                                    " off on ",
                                    convertType(coupon.type)
                                )
                            }}
                        </div>
                        <div
                            v-if="coupon.point_needed"
                            class="coupon-points theme-primary-color"
                        >
                            {{ coupon.point_needed.toFixed(2) }} {{ cartTranslations.pts ?? "PTS" }}
                        </div>
                    </div>
                </div>
                <div class="coupon-rules discount">
                    <div
                        v-if="coupon.discount_type == 'percentage'"
                        class="value"
                    >
                        {{
                            cartTranslations.percentage_off.replace(":discount", coupon.discount) ??
                            coupon.discount.concat("% Off")
                        }}
                    </div>
                    <div
                        v-else
                        class="value"
                    >
                        {{
                            cartTranslations.absolute_off
                                .replace(":currency", currencySymbol)
                                .replace(":amount", coupon.discount)
                        }}
                    </div>
                </div>
                <div
                    v-if="coupon.min_document_amount"
                    class="min-spend"
                >
                    {{ cartTranslations.min_spend ?? "Min. Spend" }} {{ currencySymbol }}
                    {{ coupon.min_document_amount }}
                </div>
                <!-- <div
                    v-if="coupon.min_document_amount"
                    class="coupon-rules min-spend"
                >
                    <div class="title">{{ cartTranslations.min_spend ?? "Min. Spend" }}</div>
                    <div class="value">{{ currencySymbol }} {{ coupon.min_document_amount }}</div>
                </div> -->
                <!-- <div v-if="coupon.max_amount_limit" class="coupon-rules capped-at">
                        <div class="title">Capped At</div>
                        <div class="value theme-primary-color">{{currencySymbol}} {{ coupon.max_amount_limit }}</div>
                    </div> -->
            </div>

            <div
                v-if="coupon.discount_type == 'percentage'"
                class="coupon-badge"
            >
                {{ coupon.discount }}%
            </div>
            <div
                v-else
                class="coupon-badge"
            >
                {{ currencySymbol }}{{ coupon.discount }}
            </div>
        </div>
        <div v-if="Object.values(coupons).length <= 0">
            <div class="no-result-found">
                <bo-svg
                    :svg-content="'/assets/graphics/img-no-data.svg'"
                    :primary-color="primaryColor"
                ></bo-svg>
                <div class="title">{{ cartTranslations.no_results ?? "No results found" }}</div>
                <!-- <div class="subtitle">Currently does not have any data to display</div> -->
            </div>
        </div>
    </div>
</template>

<script>
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);
import Vue from "vue";
import moment from "moment";

Vue.component("bo-toast", require("@/v2/components/bo-toast.vue").default);

export default {
    props: {
        coupons: {
            type: Object,
            default: null,
        },
        button: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            primaryColor: window.bo_primary_color || '#594c45',
            generalTranslations: window.bo?.generalTranslations ?? {},
            cartTranslations: window.bo?.cartTranslations ?? {},
            currencySymbol: window.bo?.currencySymbol ?? "RM",
            dateFormat: window.bo?.dateFormat ?? "DD MMM YYYY",
            timeFormat: window.bo?.timeFormat ?? "hh:mm A",
            momentLocale: window.bo?.generalTranslations?.momentlocale ?? "en",
        };
    },

    methods: {
        convertDate(dbDate) {
            const date = new Date(dbDate);
            return moment(date).locale(this.timeFormat).format(this.dateFormat);
        },
        convertType(type) {
            switch (type) {
                case "cart_discount":
                    return window.bo?.cartTranslations?.cart_discount ?? "Cart Discount";
                case "product_discount":
                    return window.bo?.cartTranslations?.product_discount ?? "Product Discount";
                case "product_discount_on_msrp":
                    return window.bo?.cartTranslations?.product_discount_on_msrp ?? "Product Discount On MSRP";
                default:
                    return window.bo?.cartTranslations?.wrong_type ?? "Wrong Type";
            }
        },
        onClick(coupon) {
            this.$emit("on_click", coupon);
        },
    },

    computed: {
        formattedCoupons() {
            if (this.coupons) {
                return Object.values(this.coupons).map((coupon) => {
                    return {
                        ...coupon,
                        discount: parseFloat(coupon.discount).toFixed(2),
                    };
                });
            }
        }
    }
};
</script>
